<template>
  <div class="container">
          <div class="row pt-3 px-3 pb-2">
            <div class="col-md-4 col-6 px-3 p-0 px-md-2 mb-3 d-flex align-items-stretch" v-for="(project, index) in projects" :key="index">
              <div class="card category w-100 text-center">
                <div class="card-body list">
                  <a href="#/" @click="showModal(project)">
                    <div><i :class="`fa-solid fa-${project.icon}`"></i></div>
                    <div class="list-heading">{{ project.title }}</div>
                    <div class="list-budget">{{ formattedPrice(project.budget) }}</div>
                    </a>
                </div>
              </div>
            </div>
          </div>
      <confirm-project :project="selectedProject" @create-project="createProject"></confirm-project>
      </div>
</template> 

<script>
import "vue-select/dist/vue-select.css";

export default {

  data() {
    return {
      sent: false,
      selectedProject: {},
      projects: [
        {id: 1, 
        title: '5 Business Logos', icon: 'layer-group',
        description: 'I need a logo for my business. Design 5 options for me to choose from.', 
        budget: 50, category: 17},
        {id: 2, 
        title: '10 Business Logos', icon: 'layer-group',
        description: 'I need a logo for my business. Design 10 options for me to choose from.', 
        budget: 100, category: 17},
        {id: 3, 
        title: '15 Business Logos', icon: 'layer-group',
        description: 'I need a logo for my business. Design 15 options for me to choose from.', 
        budget: 150, category: 17},

      ],
      loading_categories: false,
    };
  },

  methods: {

     showModal(project) {
      this.selectedProject = project;
      this.$bvModal.show("bv-modal-example");
    },

    createProject(project) {
      console.log(project);
        this.$emit('create-project', project);
    },

  },
};
</script>

<style scoped>
.list-heading {font-weight:500;}
.list-budget {font-weight:400;}
</style>